import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import React from 'react'

type Props = {
  title: string
  value: string
}

export default function EmployeeDetailsItem({ title, value }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <Typography sx={{ width: 110 }} variant="subtitle2">
        {title}
      </Typography>
      <Typography variant="body2">{value || '-'}</Typography>
    </Box>
  )
}
